import { Directive, ElementRef, Input,Output, EventEmitter } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { RouteId } from 'src/app/enums/env/routes-id-enum';
import { FiltersKey } from 'src/app/enums/search-key.enum';
import { FilterByPage } from 'src/app/interfaces/filtres/filter-interface';
import { SearchService } from 'src/app/modules/search/services/search.service';
import { environment } from 'src/environments/environment';

@Directive({
    selector: '[appChangeRouterlink]',
    standalone: false
})
export class ChangeRouterlinkDirective {
  
  @Input() routeId: RouteId;
  @Output() setLink : EventEmitter<FilterByPage<FiltersKey>> = new EventEmitter<FilterByPage<FiltersKey>>();
  constructor(
    private searchService: SearchService,
    private el: ElementRef,
  ) { 
  }
  
  @Input() routerLink : any;
  @Output() routerLinkChange = new EventEmitter<string>();;
  ngOnInit() {
    
    this.routerLink = this.changeLink();
    this.routerLinkChange.emit(this.routerLink)
    //this.el.nativeElement.href = this.changeLink()
  }
  
  changeLink()  {
    const filterByPage : FilterByPage<FiltersKey> = this.searchService.getSearchByRouteId(this.routeId);
    const nameOnLink = environment.core.routes.find(elm => elm.id == this.routeId).route;
    var link =  `${nameOnLink}`;
    // aprés avoir récupérer les filtres de la page on créer le lien
    if(filterByPage){
      link += "?";
      for(let param of filterByPage.params){
        link += `${param.key}=${param.value}&`;
      }
    }
    return link;
    //this.setLink.emit(filterByPage);
  }
}
